import { GridColDef } from "@mui/x-data-grid";
import { renderActive } from "../../../../component/list/table-column-renders";
import { Stream } from "../../model/stream";
import { Button } from "@mui/material";
import GroupsIcon from '@mui/icons-material/Groups';

export const columns = (openGroups: (stream: Stream) => void): GridColDef[] => [
    { field: 'name', headerName: 'Name', flex: 1.5 },
    { field: 'active', headerName: 'Active', flex: 0.5, renderCell: (params) => { return renderActive(params.row.active) } },
    {
        field: 'actions',
        headerName: 'Groups',
        flex: 0.5,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
            return (
                <Button
                    size="small"
                    startIcon={<GroupsIcon />}
                    onClick={(e) => {
                        e.stopPropagation();
                        openGroups(params.row as Stream);
                    }}
                >
                    Groups
                </Button>
            );
        }
    }
];
